import axios from 'axios';
import {
	req,
	reqF,
} from './axiosFun';


export const GetExportHistoryPageList = (params) => {
	return reqF("post", "/api/sysConfig/Common/GetExportHistoryPageList", params)
};